import { MahnungPositionDto } from "./mahnungPositionDto";
import { MahnungAuditDto } from "./mahnungAuditDto";
import { AddressDto } from "./addressDto";

export class MahnungDto {
	public mahnungsId: number = 0;
	public createdAt: Date = new Date();
	public changedAt: Date = new Date();
	public mahnungsDatum: Date = new Date();
	public customerId: number = 0;
	public mahnungCost: number = 0;
	public currency: string = "";
	public note: string = "";
	public selected: boolean = false;
	public invoiceAddress: AddressDto = new AddressDto();
	public customerAddress: AddressDto = new AddressDto();
	public reminderAddress: AddressDto = new AddressDto();
	public customerAddresses: AddressDto[] = new Array<AddressDto>();
	public mahnungsPositions: MahnungPositionDto[] = new Array<MahnungPositionDto>();
	public audits: MahnungAuditDto[] = new Array<MahnungAuditDto>();
}
